import { useParams } from 'react-router-dom';
import { addLanguageToPath } from 'src/utils/languages';
import type { LanguageCode } from 'src/utils/languages';

/**
 * Hook to get language-aware navigation utilities
 */
export function useLanguageNavigation() {
  const params = useParams<{ lang?: string }>();
  const currentLang = (params.lang?.toLowerCase() || 'en') as LanguageCode;

  /**
   * Get a path with the current language prefix
   */
  const getLocalizedPath = (path: string): string => {
    // If path already starts with a language code, return as is
    if (path.startsWith('/') && path.split('/').length > 1) {
      const segments = path.split('/').filter(Boolean);
      // Check if first segment is a language code (2 letters)
      if (segments[0]?.length === 2) {
        return path;
      }
    }

    // Add current language prefix
    return addLanguageToPath(path, currentLang);
  };

  return {
    currentLang,
    getLocalizedPath,
  };
}
